import { makeContext } from 'components/StackNavigation'

const StackContext = makeContext()

export default StackContext
